import { Content_Block } from "../ContentBlock";

export class ButtonBlock extends Content_Block{
    constructor(){
        super("button");
        this.url = "https://sportips.fr";
        this.text = "Cliquer ici"
        this.alignement = "center";
        this.color = "#FFF";
        this.background_color = "";
        
    }
}